import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'


@Component({
    selector: 'asda-logout-popup',
    templateUrl: './asda-logout-popup.component.html',
    styleUrls: ['./asda-logout-popup.component.scss'],
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
    ],
})
export class AsdaLogoutPopupComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string }) {

    }

}
